module.exports = __webpack_public_path__ + "img/van-grey.4f3a7646.svg";